import { Component, Input, EventEmitter, Output } from '@angular/core';

import { DescriptionDto, TranslationDetailsDto } from '../../../shared/model';

@Component({
  selector: 'app-descriptions-view',
  templateUrl: './descriptions-view.component.html',
  styleUrls: [
    './descriptions-view.component.css',
    '../keywords-view.component.css',
    '../../admin-grid.css',
    '../../../shared/styles/confirm-dialog.css'
  ]
})
export class DescriptionsViewComponent {

  @Input() descriptions: DescriptionDto[];

  @Output() descriptionVerified: EventEmitter<number> = new EventEmitter();
  @Output() generatingFromDescription: EventEmitter<number> = new EventEmitter();
  @Output() keywordGenerated: EventEmitter<TranslationDetailsDto> = new EventEmitter();

  verifyOpened: boolean;
  currentDescriptionId: number;

  constructor() { }

  verifyDescription(id: number) {
    this.currentDescriptionId = id;
    this.verifyOpened = true;
  }

  verifyConfirmed() {
    this.descriptionVerified.emit(this.currentDescriptionId);
    this.verifyClose();
  }

  verifyClose() {
    this.verifyOpened = false;
    this.currentDescriptionId = null;
  }

  generateKeyword(issue: DescriptionDto) {
    const keyword = <TranslationDetailsDto>{};
    keyword[issue.LanguageName] = issue.MismatchedKeyword;

    this.generatingFromDescription.emit(issue.Id);
    this.keywordGenerated.emit(keyword);
  }
}
